const { createSlice } = require("@reduxjs/toolkit");

const invitationSlice = createSlice({
  name: "invitation",
  initialState: {
    isFilterMenuOpen: false,
    invitationList: [],
    allInviattionData: null,
    actionableInvitationId: null,
    isInvitationCancleModalOpen: false,
    isInvitationDeleteModalOpen: false,
    isInvitationResendModalOpen: false,
    selectedCompanyId: null,
    selectedCompanyType: null,
    isDeletePertnerModalOpen: false,
    searchedPartnersData: null,

  },
  reducers: {
    toggleIsFilterMenuOpen: (state) => ({
      ...state,
      isFilterMenuOpen: !state.isFilterMenuOpen,
    }),
    setInvitationList: (state, action) => {
      if (action.payload.append) {
        return {
          ...state,
          invitationList: [action.payload.invitation, ...state.invitationList],
        };
      } else {
        return {
          ...state,
          invitationList: action.payload.invitationList,
        };
      }
    },
    setAllInviattionData: (state, action) => ({
      ...state,
      allInviattionData: action.payload ?? null,
    }),
    toggleActionableInvitationId: (state, action) => ({
      ...state,
      actionableInvitationId: action.payload,
    }),
    toggleSelectedCompanyId: (state, action) => ({
      ...state,
      selectedCompanyId: action.payload,
    }),
    toggleSelectedCompanyType: (state, action) => ({
      ...state,
      selectedCompanyType: action.payload,
    }),
    toggleInvitationCancleModal: (state, action) => ({
      ...state,
      isInvitationCancleModalOpen: !state.isInvitationCancleModalOpen,
    }),
    toggleInvitationDeleteModal: (state, action) => ({
      ...state,
      isInvitationDeleteModalOpen: !state.isInvitationDeleteModalOpen,
    }),
    toggleDeletePertnerModal: (state, action) => ({
      ...state,
      isDeletePertnerModalOpen: !state.isDeletePertnerModalOpen,
    }),
    toggleInvitationResendModalOpen: (state, action) => ({
      ...state,
      isInvitationResendModalOpen: !state.isInvitationResendModalOpen,
    }),
    setSearchedPartnersData: (state, action) => ({
      ...state,
      searchedPartnersData: action.payload.searchedPartnersData ?? null,
    }),

  },
});

export const {
  toggleIsFilterMenuOpen,
  setInvitationList,
  setAllInviattionData,
  toggleActionableInvitationId,
  toggleInvitationCancleModal,
  toggleInvitationDeleteModal,
  toggleInvitationResendModalOpen,
  toggleSelectedCompanyId,
  toggleSelectedCompanyType,
  toggleDeletePertnerModal,
  setSearchedPartnersData
} = invitationSlice.actions;
export default invitationSlice.reducer;
